"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setText = exports.drawAll = exports.close = exports.isOpen = exports.open = exports.get = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var rogueMonofont_sidecar_1 = require("@dive/fonts/rogueMonofont-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isOpen: false,
            text: '',
        };
    }
    return _obj;
};
exports.get = get;
var open = function () {
    var obj = exports.get();
    obj.isOpen = true;
    // rogueUiDead.close()
};
exports.open = open;
var isOpen = function () {
    return exports.get().isOpen;
};
exports.isOpen = isOpen;
var close = function () {
    var obj = exports.get();
    obj.isOpen = false;
};
exports.close = close;
var drawAll = function () {
    var obj = exports.get();
    if (!obj.isOpen) {
        return;
    }
    var x = 1;
    var y = 1;
    var offsetAmount = 0.06;
    var offsets = [
        [-1, -1],
        [1, 1],
        [-1, 1],
        [1, -1],
    ];
    for (var i = 0; i < offsets.length; i++) {
        var offset = offsets[i];
        rogueMonofont_sidecar_1.rogueMonofont.write(x + offset[0] * offsetAmount, y + offset[1] * offsetAmount, '' + obj.text, rogueColors_1.rogueColors.darkBlue, rogueColors_1.rogueColors.none);
    }
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, '' + obj.text, rogueColors_1.rogueColors.light, rogueColors_1.rogueColors.none);
};
exports.drawAll = drawAll;
var setText = function (text) {
    var obj = exports.get();
    obj.text = text;
};
exports.setText = setText;
